import React, { useEffect, useState, useCallback } from 'react';

import { connect } from 'react-redux';
import { toast } from "react-toastify"

// jwtService
import jwtService from 'jwtService';

// custom hooks
import useUserActivity from 'hooks/useUserActivity';
import useCrossTabLogout from 'hooks/useCrossTabLogout';
import { triggerCrossTabLogout } from 'hooks/useCrossTabLogout/triggerCrossTabLogout';


export const SessionSupport = (props) => {
	const isAdLogin = localStorage.getItem('isAdLogin') || '';
	const isSsoLogin = localStorage.getItem('isSsoLogin') || '';

	const handleInactivity = useCallback(() => {
		const isAdLogin = localStorage.getItem('isAdLogin') || '';
		const isSsoLogin = localStorage.getItem('isSsoLogin') || '';
		let ssoConfig = null;
		let userEmailReport = localStorage.getItem('userEmailReport')
		if (userEmailReport) {
			let emailCheckData = JSON.parse(window.atob(userEmailReport))
			ssoConfig = emailCheckData?.ssoConfig
		}
		console.log("isSsoLogin , isAdLogin", isAdLogin !== 'true' && isSsoLogin !== 'true', isAdLogin, isSsoLogin)
		// Don't call refresh token in both scenarios
		if (isAdLogin !== 'true' && (isSsoLogin !== 'true' || (isSsoLogin == 'true' && ssoConfig?.system === 'pingID'))) {
			toast.info('Session expired due to inactivity.', { toastId: 'logout-session' })
			// TODO: Clear session data, redirect to login, etc.
			triggerCrossTabLogout(); // Notify other tabs
			const jwt_access_token = localStorage.getItem('jwt_access_token')
			if (jwt_access_token)
				jwtService.logout()
		}
	}, []);

	const handleCrossTabLogout = useCallback(() => {
		// Same logout logic (without sending the message again to avoid loops)
		const jwt_access_token = localStorage.getItem('jwt_access_token')
		if (jwt_access_token)
			jwtService.logout()
	}, []);

	// ✅ Always call hooks unconditionally (React Rules of Hooks requirement)
	// The hooks themselves handle the conditional logic internally via refs
	const lastActivity = useUserActivity(handleInactivity);
	useCrossTabLogout(handleCrossTabLogout);

	return <React.Fragment></React.Fragment>
};

const mapDispatchToProps = {
};

const mapStateToProps = state => {
	return {
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionSupport);
